import makeStyles from "@mui/styles/makeStyles";
import { styled } from "@mui/material/styles";
import { colors } from "@zapalacorp/tokens";
import { getBrandCustom } from "../../../../../../../../../../util/getCustomColor";

export const DetailsHeader = styled("header")(() => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  borderBottom: `1px solid ${colors.gray200}`,
  padding: 24,
}));

type Props = {
  hasSubcontractor?: boolean;
};

export const HeaderMessage = styled("span")(({ hasSubcontractor = false }: Props) => ({
  fontFamily: "Manrope",
  fontSize: 16,
  fontWeight: 400,
  lineHeight: "24px",
  letterSpacing: 0.5,
  color: colors.gray600,
  "& > span": {
    fontWeight: 700,
    letterSpacing: 0.15,
    color: hasSubcontractor
      ? colors.warning600
      : getBrandCustom("primaryColor", colors.brandBlue600),
  },
}));

export const ButtonWrapper = styled("div")(() => ({
  display: "flex",
  alignItems: "center",
  gap: 16,
}));

export const SectionWrapper = styled("div")(() => ({
  padding: "32px 24px",
  "& > div": {
    marginBottom: 24,
  },
  "&:not(:last-child)": {
    borderBottom: `1px solid ${colors.gray200}`,
  },
}));

export const SectionTitle = styled("span")(() => ({
  fontFamily: "Manrope",
  fontSize: 16,
  fontWeight: 600,
  lineHeight: "24px",
  letterSpacing: 0.15,
}));

export const DetailsFooter = styled("div")(() => ({
  padding: "16px 24px",
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  gap: 16,
  borderTop: `1px solid ${colors.gray200}`,
}));

export const ModalBodyWrapper = styled("div")(() => ({
  display: "flex",
  alignItems: "center",
  flexDirection: "column",
}));

export const ModalBodyText = styled("span")(() => ({
  fontSize: 16,
  fontFamily: "Manrope",
  fontWeight: 400,
  lineHeight: "24px",
  letterSpacing: 0.5,
  color: colors.gray800,
}));

export const ModalBodySubtext = styled("span")(() => ({
  fontSize: 16,
  fontFamily: "Manrope",
  fontWeight: 400,
  lineHeight: "24px",
  letterSpacing: 0.5,
  color: colors.brandBlue600,
}));

export const ModalSwitchLabel = styled("span")(() => ({
  color: colors.gray600,
  fontFamily: "Manrope",
  fontSize: 16,
  fontWeight: 400,
  lineHeight: "24px",
  letterSpacing: 0.5,
}));

export const SwitchWrapper = styled("div")(() => ({
  display: "flex",
  alignItems: "center",
  gap: 16,
  paddingBottom: 24,
  marginLeft: "-8px",
}));

const styles = makeStyles(() => ({
  modalWrapper: {
    width: "442px !important",
  },
}));

export default styles;
